import {
  $getRoot,
  $getSelection,
  $isRangeSelection,
  $isTextNode,
} from "lexical";

const DIRECTIVE_NAME_CHAR_CLASS = "[A-Za-z0-9_-]";
const DIRECTIVE_NAME_PATTERN = `[A-Za-z]${DIRECTIVE_NAME_CHAR_CLASS}*`;
const SLASH_QUERY_PATTERN = new RegExp(
  `(?:^|\\s)/((${DIRECTIVE_NAME_PATTERN})?)$`
);
const TRAILING_SLASH_QUERY_PATTERN = new RegExp(
  `/${DIRECTIVE_NAME_CHAR_CLASS}*$`
);

export const getTrailingSlashQueryMatch = (text: string) =>
  text.match(TRAILING_SLASH_QUERY_PATTERN);

export const hasTrailingSlashQuery = (text: string) =>
  TRAILING_SLASH_QUERY_PATTERN.test(text);

const getSlashQueryFromText = (text: string): string | null => {
  const match = text.match(SLASH_QUERY_PATTERN);

  return match?.[1] ?? null;
};

const getSlashQueryFromSelection = (): string | null => {
  const selection = $getSelection();
  if (!$isRangeSelection(selection) || !selection.isCollapsed()) return null;

  const anchorNode = selection.anchor.getNode();
  if (!$isTextNode(anchorNode)) return null;

  const textBeforeSelection = anchorNode
    .getTextContent()
    .slice(0, selection.anchor.offset);
  const match = getSlashQueryFromText(textBeforeSelection);

  return match;
};

export const getSlashQueryFromCurrentRead = (): string | null =>
  getSlashQueryFromSelection() ??
  getSlashQueryFromText($getRoot().getTextContent());
